import React from "react";
import './refrigeracion.css';
import TitleDisplayerComponent from "../TitleDisplayer/titledisplayer";
import { useInView } from "react-intersection-observer";
function Refrigeracion() {
    const {ref: txtRefrigeracion, inView:textRefrigeracionIsVisible} = useInView({
        "threshold":.9,
        "initialInView":true
    })
    const {ref:txtListRef, inView:txtListRefIsVisible} = useInView({
        "threshold":.9,
        "initialInView":true
    }) 
    const {ref:imagen4, inView:imagen4IsVisible} = useInView({
        "threshold":.9,
        "initialInView":true
    })
    const {ref: CotizarWhap, inView:cotizarWhapIsVisible} = useInView({})
    return (
        <div class="wrapContentRefrigeracion" id="refrigeracion">
            <div class="RefrigeracionFlexWrap">
                <div class="WrapTextRefrigeracion">
                    <div class="titleRefrigeracion">
                        <TitleDisplayerComponent text="Refrigeración Serdán" id="RefrigeracionTxtTitle" />
                    </div>
                    <div ref={txtRefrigeracion} className={`TxtContentRefrigeracion ${textRefrigeracionIsVisible ? "TxtContentRefrigeracionAnimated" : "" }`}>
                        <h4>Venta y servicio de mantenimiento y reparación de los mejores equipos de fabricación:</h4>
                        <div ref={txtListRef} className="UlWrapRefrigeracion">
                            <ul ref={txtRefrigeracion} className={`listRefWrap ${txtListRefIsVisible ? "listRefWrapAnimation" : ""}`}>
                                <li className={`ListRefrigeracion ${textRefrigeracionIsVisible ? "ListRefrigeracionAnimation1" : ""}`}><strong>Industrial</strong></li>
                                <li className={`ListRefrigeracion ${textRefrigeracionIsVisible ? "ListRefrigeracionAnimation2" : ""}`}><strong>Comercial</strong></li>
                                <li className={`ListRefrigeracion ${textRefrigeracionIsVisible ? "ListRefrigeracionAnimation3" : ""}`}><strong>Domestico</strong></li>
                            </ul>
                        </div>
                    </div>
                    
                        <div class="WrapWhapText">
                        <div ref={CotizarWhap} className={`CotizarWhap ${cotizarWhapIsVisible ? "CotizarWhapAnimated" : ""}`}>
                        <a id="botonLinkWhapp" href="https://wa.me/6681316676" target="_blank">
                        <img src="./Images/whatsapp.png" style={{
                                width:"50px", height:"50px"
                            }}/>
                                <h3 className="CotizarTxt">Cotizar</h3>
                                </a>
                            </div>
                           
                       </div>
                </div>
                
                <div className="ImageWrapRefrigeracion">
                    <div className="RefrigeracionImageEmpresa">
                        <img ref={imagen4} src="./Images/Encabezado Refrigeración Serdán 4-03-01.png" className={`imgSizeRefrigeracion ${imagen4IsVisible ? "imgSizeRefrigeracionAnimation" : ""}`} alt="" />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Refrigeracion;
